import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';
import { withTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';

import SortableList, { SortableItem } from 'react-easy-sort'
import {arrayMoveImmutable} from 'array-move';
import PortletContent from 'components/PortletContent';
import { styled } from '@mui/material/styles';
import { BoardCard } from './BoardCard';
import { Box } from '@material-ui/core';

import { getCardOrder, updateFavoritesOrder } from '../../services/favoritesOrder/index';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#E8E8E8',
  ...theme.typography.body2,
  padding: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

// Component styles
const styles = theme => ({
    root: {
        "& .MuiPaper-root": {
            borderColor: '#fff'
        },
        padding: theme.spacing(3),
        backgroundColor: '#ECECEC',
        height: '100%',
    },
    item: {
        height: '100%',
        width: '100%',
    },
       
    item2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        height: '400px',
        cursor: 'grab',
        fontSize: '20px',
        userSelect: 'none',
        borderColor: '#000',
        width: '45vw'
    },
    list: {
        userSelect: 'none',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
    },
    popover:{
        width:"67%",
        [theme.breakpoints.down('md')]: {
            width: '80%',
        },
    },
    popoverLights:{
        width:"90%",
    },
    popoverPorlet:{
        backgroundColor:"#0b1738",
    },
    popoverPorletLights:{
        backgroundColor:"grey",
        width:"100%",
    },
    textColorPopover:{
        color:"white"
    },
    stopRed:{
        color:"#C2272D"
    },
    stopGreen:{
        color:"#41B900"
    },
    stopYellow:{
        color:"#FFC600"
    },
    stopGray:{
        color:"#a9a9a9"
    },
    stopBlue:{
        color:"#1976d2"
    },
    stopWhite:{
        color:"#ffffff"
    },
    containerImg: {
        width: 'auto',
        maxWidth: "100%",
        height: 320,
        [theme.breakpoints.down('md')]: {
            height: 180,
        },
    },
});


class Boards extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.onSortEnd= this.onSortEnd.bind(this);
        sessionStorage.setItem('fromBoards', false)
        this.state = {
            objectivesList: {},
            items: null,
            isMoreExpand: null,
            keyMoreBoard:-1,
            isInfoQV:null,
            isInfoFV:null,
            isInfoGS:null,
            isInfoVRPI:null,
            isInfoVRPIC:null,
            isInfoS:null,
            isInfoVRPI: null,
            isInfoVRPIC: null,
            isInfoS: null,
            isInfoCO: null
        } 
    }

    componentDidMount() {
        if (this.state.items === null) {
            getCardOrder().then(cardOrder => {
                if (cardOrder === null) {
                    this.setState({ items: this.getDefaultItems() });
                } else {
                    cardOrder.forEach((item, index) => {
                        item.key = index;
                        switch(item.id) {
                            case 0:
                                item['modal'] = this.handleShowIsInfoQuickView;
                                break;
                            case 1:
                                item['modal'] = this.handleShowIsInfoFastView;
                                break;
                            case 2:
                                item['modal'] = this.handleShowIsInfoGeneralStatus;
                                break;
                            case 3:
                                item['modal'] = this.handleShowIsInfoVRPI;
                                break;
                            case 4:
                                item['modal'] = this.handleShowIsInfoVRPIC;
                                break;
                            case 5:
                                item['modal'] = this.handleShowIsInfoS;
                                break;
                            case 6:
                                item['modal'] = this.handleShowIsInfoCO;
                                break;
                            case 7:
                                item['modal'] = this.handleShowIsInfoApdex;
                                break;
                            default:
                                item['modal'] = null;
                        }
                    });
                    this.setState({ items: cardOrder });
                }
            }).catch(error => {
                console.error("Error:", error);
            });
        }
    }

    getDefaultItems() {
        const t = this.props && this.props.t ? this.props.t : (k => k);
        return [
            {id: 0, name: t('fav-boards.card.operative-status.title'), enabled: true, key: 0, link: '/estadoOperativo', modal: this.handleShowIsInfoQuickView},
            {id: 1, name: t('fav-boards.card.quickview.title'), enabled: true, key: 1, link: '/quickview', modal: this.handleShowIsInfoFastView},
            {id: 2, name: t('fav-boards.card.general-status.title'), enabled: true, key: 2, link: '/generalStatus', modal: this.handleShowIsInfoGeneralStatus},
            {id: 3, name: t('fav-boards.card.quickview-isp.title'), enabled: true, key: 3, link: '/quickviewisplights?tab=1', modal: this.handleShowIsInfoVRPI},
            {id: 4, name: t('fav-boards.card.quickview-isp-compact.title'), enabled: false, key: 4, link: '/quickviewisplights?tab=2', modal: this.handleShowIsInfoVRPIC},
            {id: 5, name: t('fav-boards.card.traffic.light.title'), enabled: false, key: 5, link: '/quickviewisplights?tab=3', modal: this.handleShowIsInfoS},
            {id: 6, name: t('fav-boards.compare-objectives.title'), enabled: false, key: 6, link: '/comparisonObjectives', modal: this.handleShowIsInfoCO},
            {id: 7, name: t('fav-boards.card.apdex.title'), enabled: false, key: 7, link: '/apdex', modal: this.handleShowIsInfoApdex}
        ]
    }

    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }
    
    onSortEnd = (oldIndex, newIndex) => {
        const newState = { ...this.state };
        const array1 = arrayMoveImmutable(newState['items'], oldIndex, newIndex);
        array1.forEach((item, index) => {
            item.key = index;
            switch(item.id) {
                case 0:
                    item['modal'] = this.handleShowIsInfoQuickView;
                    break;
                case 1:
                    item['modal'] = this.handleShowIsInfoFastView;
                    break;
                case 2:
                    item['modal'] = this.handleShowIsInfoGeneralStatus;
                    break;
                case 3:
                    item['modal'] = this.handleShowIsInfoVRPI;
                    break;
                case 4:
                    item['modal'] = this.handleShowIsInfoVRPIC;
                    break;
                case 5:
                    item['modal'] = this.handleShowIsInfoS;
                    break;
                case 6:
                    item['modal'] = this.handleShowIsInfoCO;
                    break;
                case 7:
                    item['modal'] = this.handleShowIsInfoApdex;
                    break;
                default:
                    item['modal'] = null;
            }
        });
        newState['items'] = array1
        this.setState(newState);
        updateFavoritesOrder(JSON.stringify(newState.items));
    }

    handleClose = value => () => {
        const newState = { ...this.state };
        newState['items'][value]['enabled'] = false
        this.onSortEnd(newState['items'][value]['key'], 3)
    };

    handleAdd = value => () => {
        const newState = { ...this.state };
        newState['items'][value]['enabled'] = true
        newState['items'][value]['key'] = newState['keyMoreBoard']
        if (value !== newState['keyMoreBoard']){
            newState['items'][newState['keyMoreBoard']]['enabled'] = false
            newState['items'][newState['keyMoreBoard']]['key'] = value
        }
        newState['items'].sort(function (a, b) {
            return (a.key - b.key);
        });
        newState['isMoreExpand'] = null
        this.setState(newState);
        updateFavoritesOrder(JSON.stringify(newState.items));
    };

    handleMore = event => {
        const newState = { ...this.state };
        this.setState({
            isMoreExpand: event.currentTarget,
            keyMoreBoard: parseInt(event.currentTarget.id)
        });
    };
    handleCloseMore = () => {
        this.setState({
            isMoreExpand: null
        });
    };
    handleOpenNew= () => {
        sessionStorage.setItem('fromBoards', true)
    };

    handleShowIsInfoQuickView = event => {
        this.setState({
            isInfoQV: event.currentTarget
        });
    };

    handleCloseIsInfoQuickView = () => {
        this.setState({
            isInfoQV: null
        });
    };

    handleShowIsInfoFastView = event => {
        this.setState({
            isInfoFV: event.currentTarget
        });
    };

    handleCloseIsInfoFastView = () => {
        this.setState({
            isInfoFV: null
        });
    };

    handleShowIsInfoGeneralStatus = event => {
        this.setState({
            isInfoGS: event.currentTarget
        });
    };

    handleCloseIsInfoGeneralStatus = () => {
        this.setState({
            isInfoGS: null
        });
    };

    handleShowIsInfoVRPI = event => {
        this.setState({
            isInfoVRPI: event.currentTarget
        });
    };

    handleCloseIsInfoVRPI = () => {
        this.setState({
            isInfoVRPI: null
        });
    };

    handleShowIsInfoVRPIC = event => {
        this.setState({
            isInfoVRPIC: event.currentTarget
        });
    };

    handleCloseIsInfoVRPIC = () => {
        this.setState({
            isInfoVRPIC: null
        });
    };

    handleShowIsInfoS = event => {
        this.setState({
            isInfoS: event.currentTarget
        });
    };

    handleCloseIsInfoS = () => {
        this.setState({
            isInfoS: null
        });
    };

    handleShowIsInfoCO = event => {
        this.setState({
            isInfoCO: event.currentTarget
        });
    };

    handleCloseIsInfoCO = () => {
        this.setState({
            isInfoCO: null
        });
    };

    handleShowIsInfoApdex = event => {
        this.setState({
            isInfoApdex: event.currentTarget
        });
    };

    handleCloseIsInfoApdex = () => {
        this.setState({
            isInfoApdex: null
        });
    };

    render() {
        const { classes, t } = this.props;
        const { items, isMoreExpand, isInfoQV, isInfoFV, isInfoGS, isInfoVRPI, isInfoVRPIC, isInfoS, isInfoCO, isInfoApdex} = this.state
        const showIsMoreExpand = Boolean(isMoreExpand);
        const showIsInfoQV = Boolean(isInfoQV);
        const showIsInfoFV = Boolean(isInfoFV);
        const showIsInfoGS = Boolean(isInfoGS);
        const showIsInfoVRPI = Boolean(isInfoVRPI);
        const showIsInfoVRPIC = Boolean(isInfoVRPIC);
        const showIsInfoS = Boolean(isInfoS);
        const showIsInfoCO = Boolean(isInfoCO);
        const showIsInfoApdex = Boolean(isInfoApdex);
        return (
            <div>
                {/* <UserNotification /> */}
                <DashboardLayout title={t('sidebar.option.title.fav-boards')} callbackFromParent={this.myCallback} isFirstTime={true}>
                    <div className={classes.root}>
                        <Box paddingTop={1} paddingBottom={3} paddingLeft={2} paddingRight={2}>
                            <Typography>
                                {t('fav-boards.text.note')}
                            </Typography>
                        </Box>
                        <SortableList onSortEnd={this.onSortEnd} className={classes.list} draggedItemClassName="dragged">
                            <Grid container spacing={5}>
                            {items && items.slice(0, 4).map(({id, name, enabled, key, link, modal }) => (
                                <Grid item lg={6} md={6} sm={12} key={key}>
                                    <BoardCard
                                        id={id}
                                        name={name}
                                        enabled={enabled}
                                        keyTwo={key}
                                        link={link}
                                        modal={modal}
                                        items={items}
                                        classes={classes}
                                        showIsMoreExpand={showIsMoreExpand}
                                        isMoreExpand={isMoreExpand}
                                        handleMore={this.handleMore}
                                        handleOpenNew={this.handleOpenNew}
                                        handleClose={(value) => this.handleClose(value)}
                                        handleCloseMore={this.handleCloseMore}
                                        handleAdd={(value) => this.handleAdd(value)}
                                    />
                                </Grid>
                            ))}
                            </Grid>
                        </SortableList>
                        <Popover
                            anchorEl={isInfoQV}
                            open={showIsInfoQV}
                            onClose={this.handleCloseIsInfoQuickView}
                            className={classes.popover}
                            anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                            }}
                            transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                            }}
                            >
                                <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                    {t('fav-boards.card.operative-status.about.text-1')}
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                    {t('fav-boards.card.operative-status.about.text-2')}
                                </Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.operative-status.about.text-3')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.operative-status.about.text-4')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.operative-status.about.text-5')}</Typography>
                                </Grid>
                                <Divider/>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    {t('fav-boards.card.operative-status.about.text-6')}
                                </Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoFV}
                            open={showIsInfoFV}
                            onClose={this.handleCloseIsInfoFastView}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                    <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.quickview.about.text-1')}</Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.quickview.about.text-2')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.quickview.about.text-3')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.quickview.about.text-4')}</Typography>
                                </Grid>
                                <Divider/>
                                <Typography variant="body1" className={classes.textColorPopover}>{t('fav-boards.card.quickview.about.text-5')}</Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoGS}
                            open={showIsInfoGS}
                            onClose={this.handleCloseIsInfoGeneralStatus}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                            <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.general-status.about.text-1')}</Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopRed} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.general-status.about.text-2')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.general-status.about.text-3')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.general-status.about.text-4')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGray} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.general-status.about.text-5')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopBlue} /><Typography variant="body2" className={classes.textColorPopover}>{": " + t('fav-boards.card.general-status.about.text-6')}</Typography>
                                </Grid>
                                <Divider/>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    {t('fav-boards.card.general-status.about.text-7')}
                                </Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoVRPI}
                            open={showIsInfoVRPI}
                            onClose={this.handleCloseIsInfoVRPI}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.quickview-isp.about.text-1')}</Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoVRPIC}
                            open={showIsInfoVRPIC}
                            onClose={this.handleCloseIsInfoVRPIC}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.quickview-isp-compact.about.text-1')}</Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoS}
                            open={showIsInfoS}
                            onClose={this.handleCloseIsInfoS}
                            className={classes.popoverLights}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.traffic.light.about.text-1')}</Typography>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.card.traffic.light.about.text-2')}</strong> {t('fav-boards.card.traffic.light.about.text-3')} <StopIcon className={classes.stopGreen} />
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.card.traffic.light.about.text-4')}</strong> {t('fav-boards.card.traffic.light.about.text-5')} <StopIcon className={classes.stopYellow} />
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.card.traffic.light.about.text-6')}</strong> {t('fav-boards.card.traffic.light.about.text-7')} <StopIcon className={classes.stopRed} />
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.card.traffic.light.about.text-8')}</strong> {t('fav-boards.card.traffic.light.about.text-9')} <StopIcon className={classes.stopWhite} />
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover}>
                                    <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.card.traffic.light.about.text-10')}</strong> {t('fav-boards.card.traffic.light.about.text-11')} <StopIcon className={classes.stopWhite} />
                                </Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoCO}
                            open={showIsInfoCO}
                            onClose={this.handleCloseIsInfoCO}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.compare-objectives.about.text-1')}</Typography>
                                <Divider style={{ margin:  '10px 0px 10px 0px' }}/>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.compare-objectives.about.text-2')}</strong> {t('fav-boards.compare-objectives.about.text-3')}
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.compare-objectives.about.text-4')}</strong> {t('fav-boards.compare-objectives.about.text-5')}
                                </Typography>
                                <Divider style={{ margin:  '10px 0px 10px 0px' }}/>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.compare-objectives.about.text-6')}</strong> {t('fav-boards.compare-objectives.about.text-7')}
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.compare-objectives.about.text-8')}</strong> {t('fav-boards.compare-objectives.about.text-9')}
                                </Typography>
                                <Typography variant="body1" className={classes.textColorPopover} >
                                <strong style={{ textDecoration: 'underline' }}>{t('fav-boards.compare-objectives.about.text-10')}</strong> {t('fav-boards.compare-objectives.about.text-11')}
                                </Typography>
                            </PortletContent>
                        </Popover>
                        <Popover
                            anchorEl={isInfoApdex}
                            open={showIsInfoApdex}
                            onClose={this.handleCloseIsInfoApdex}
                            className={classes.popover}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('fav-boards.card.apdex.about.text-1')}</Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.textColorPopover}
                                >
                                    {t('fav-boards.card.apdex.about.text-2')} <StopIcon className={classes.stopRed} /><Typography variant="body2" className={classes.textColorPopover}> {t('fav-boards.card.apdex.about.text-3')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.textColorPopover}
                                >
                                    {t('fav-boards.card.apdex.about.text-4')} <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}> {t('fav-boards.card.apdex.about.text-5')}</Typography>
                                    <Typography variant="body2" className={classes.textColorPopover}>{t('fav-boards.card.apdex.about.text-6')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.textColorPopover}
                                >
                                    {t('fav-boards.card.apdex.about.text-7')} <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}> {t('fav-boards.card.apdex.about.text-8')}</Typography>
                                </Grid>
                            </PortletContent>
                        </Popover>
                    </div>
                </DashboardLayout>
            </div>
        );
    }
}

Boards.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Boards));